export default class RecapMajModaleService {
	static $inject = ['$http'];

	constructor($http) {
		this.$http = $http;
	}

	async getFiles() {
		const response = await this.$http.get(`${__configuration.apiUrl}/massia/recap-maj-files`);
		return response.data;
	}

	async downloadFile(file) {
		try {
			const response = await this.$http.get(`${__configuration.apiUrl}/massia/recap-maj-files/download`, {
				params: {
					path: file.path
				},
				responseType: 'blob'
			});

			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', file.name);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			window.URL.revokeObjectURL(url);
		} catch (err) {
			console.error('Erreur téléchargement fichier', err);
		}
	}
}
